import { FlowStepData } from "../FlowStepData";
import { MultiExecutableOutputDefinition } from "../../../Common/Execution/MultiExecutable";
import { RuleTableConfiguration } from "../../../Rule/Table/Rule/RuleTableConfiguration";
import { DataDefinition } from "../../../Common/Data/DataDefinition";

export class RunRuleTable extends FlowStepData {
    readonly __type: string = "run_rule_table";

    executable: RuleTableConfiguration = new RuleTableConfiguration();

    constructor() {
        super();

        this.executable.executionResult = new DataDefinition();
        this.name = "Run Rule Table";
    }

    getOutcomes(): MultiExecutableOutputDefinition[] {
        return [new MultiExecutableOutputDefinition("done", this.executable.getExecutionResult().fields)];
    }
}
